import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
// import lightLogo from '../assets/images/light-logo.svg';
import Banners01 from "../assets/images/banners/Banners-01.png";
import Banners02 from "../assets/images/banners/Banners-02.png";
import Banners03 from "../assets/images/banners/Banners-03.png";


const Banner = ({ slideData }) => {
    const images = {
        "Banners-01": Banners01,
        "Banners-02": Banners02,
        "Banners-03": Banners03,
    };
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const slides_json = t('homeMainSlider1', { returnObjects: true });
    const bannerSlider = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <>
            {
                slideData?.images && slideData?.images.length > 0 ? (
                    <section  id="home" >
                        {/* <img src={require("../assets/images/light-logo.png")} alt="banner-image" className='logo-white' /> */}
                        <Slider {...bannerSlider}>
                            {slideData?.images.map((image, index) => (
                                <div className='banner-info' key={"dynamic_slide_banner_" + index}>
                                    <img src={image} alt={`banner-image${index + 1}`} className='img-fluid' />
                                    <div className="banner-heading">
                                        <h1>{currentLanguage === 'ar' ? slideData?.title_ar : slideData?.title}</h1>
                                        <h4>{currentLanguage === 'ar' ? slideData?.subtitle_ar : slideData?.subtitle}</h4>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                    </section >

                ) : (
                    <section  id="home" >
                        <Slider {...bannerSlider}>
                            {slides_json && slides_json.length &&
                                slides_json.map((slide, index) =>
                                    <div className='banner-info' key={"slide_banner_" + index}>
                                        <img src={images[slide.image]} alt={slide.alt} className='img-fluid' />
                                        <div className="banner-heading">
                                            <h1>{slide.title}</h1>
                                            <h4>{slide.subtitle}</h4>
                                        </div>
                                    </div>
                                )
                            }
                        </Slider>
                    </section >
                )
            }

        </>
    );
}

export default Banner;